import React from 'react';

export const CheckboxIcon: React.FC = () => (
	<svg width='1.2rem' height='0.9rem' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M1 3.57143L4.63636 7L11 1' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
